import type { SVGProps } from "react";
import * as React from "react";

const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 11a1 1 0 1 0 0 2zm14 1 .707.707a1 1 0 0 0 0-1.414zm-6.293-7.707a1 1 0 1 0-1.414 1.414zm-1.414 14a1 1 0 0 0 1.414 1.414zM5 13h14v-2H5zm6.293-7.293 7 7 1.414-1.414-7-7zm7 5.586-7 7 1.414 1.414 7-7z"
    />
  </svg>
);
export default SvgArrowRight;
